import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from 'antd';
import {message} from './Mess'
import NewFolderModel from "./NewFolderModel";
import BaseComponent from "../../../base/BaseComponent";
import rename from '../view/Resource/img/edit-outlined.png'
import Share from "./Share";
import Removal from "./Removal";


export default class Move  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentWillMount() {
    }
    componentDidMount() {
    }

    render() {
        return(
            <div>
                <div onClick={this.showModalMover}>{
                    this.props.text?<span  style={{marginTop: 5, cursor:"pointer" }} >移动至</span>:<Button style={{marginRight: 5}} icon={"drag"}>移动至</Button>
                }
                </div>
                <Removal ref={(currentId) => this.showRemover = currentId}
                         callBack={(currentId,current,checkArray)=>{
                             this.props.callBack&&this.props.callBack()
                             // this.props.callBack&&this.props.callBack(currentId,current,checkArray,true,true)
                         }}
                > </Removal>
            </div>



        )
    }
    showModalMover=()=>{
        this.props.hideCallBack&&this.props.hideCallBack();
        if (this.props.checkArray.length) {
            this.showRemover.show(true,this.props.currentId,this.props.current,this.props.checkArray,this.props.IsDefault,this.props.IsTile,this.props.resourceName)}
        else{message.error('至少选择一个文件夹或者文件！')}

    };



}
